import { useNavigate } from "react-router-dom";
import AuthCard from "@/components/auth/AuthCard";
import AuthButton from "@/components/auth/AuthButton";
import AuthLink from "@/components/auth/AuthLink";

export default function SessionExpired() {
  const navigate = useNavigate();
  return (
    <AuthCard
      title="Session expired"
      subtitle="For your security, we signed you out after inactivity."
      footer={<AuthLink to="/auth/reset-request" testid="expired-link-reset">Forgot password?</AuthLink>}
    >
      <AuthButton onClick={() => navigate("/auth/login")} testid="expired-btn-login">
        Log in again
      </AuthButton>
      <div className="mt-3">
        <AuthButton variant="charcoal" onClick={() => navigate("/auth/login")}
                    testid="expired-btn-magic">
          Use a magic link instead
        </AuthButton>
      </div>
    </AuthCard>
  );
}
